const DOMAIN_CONFIG = {
  AUTH_DOMAIN: 'usepebble.app',
  APP_DOMAIN: 'app.usepebble.app',
  MARKETING_DOMAIN: 'usepebble.app',
  
  isAuthDomain: () => {
    const hostname = window.location.hostname;
    return hostname === DOMAIN_CONFIG.AUTH_DOMAIN || hostname === `www.${DOMAIN_CONFIG.AUTH_DOMAIN}`;
  },
  
  isAppDomain: () => {
    const hostname = window.location.hostname;
    return hostname === DOMAIN_CONFIG.APP_DOMAIN;
  },
  
  isDevelopment: () => {
    const hostname = window.location.hostname;
    return hostname === 'localhost' || 
           hostname.includes('replit') || 
           hostname.includes('127.0.0.1');
  },
  
  getAppUrl: (path = '') => {
    return `${window.location.origin}${path}`;
  },

  getAuthUrl: (path = '') => {
    return `${window.location.origin}${path}`;
  },

  redirectToApp: (path = '/', authToken = null) => {
    let url = path;
    if (authToken) {
      const separator = path.includes('?') ? '&' : '?';
      url += `${separator}authToken=${encodeURIComponent(authToken)}`;
    }
    window.location.href = url;
  },

  redirectToAuth: (path = '/login') => {
    window.location.href = path;
  },
  
  shouldShowAuthOnly: () => {
    if (DOMAIN_CONFIG.isDevelopment()) {
      return false;
    }
    return DOMAIN_CONFIG.isAuthDomain();
  },
  
  getAuthTokenFromUrl: () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('authToken');
  },
  
  clearAuthTokenFromUrl: () => {
    const url = new URL(window.location.href);
    url.searchParams.delete('authToken');
    window.history.replaceState({}, document.title, url.pathname + url.search);
  }
};

export default DOMAIN_CONFIG;
